const apiBaseUrl = window.CustomConfig.apiBaseUrl + '/shopify';

window.CustomTaxRules = {
    rules: [],
    _countryCode: null,
    _fetchPromise: null,

    async _fetchTaxRules() {
        if (!this._countryCode) {
            console.warn('CustomTaxRules: country-code is not set.');
            this.rules = [];
            return;
        }

        try {
            const res = await fetch(`${apiBaseUrl}/tax-rules/${this._countryCode}`);
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            const data = await res.json();
            this.rules = 'taxRules' in data ? data.taxRules : [];
        } catch (error) {
            console.error('Error fetching tax rules:', error);
            this.rules = [];
        }
    },

    async getTaxRules(countryCode) {
        if (this._countryCode !== countryCode || !this._fetchPromise) {
            this._countryCode = countryCode;
            this._fetchPromise = this._fetchTaxRules();
        }
        await this._fetchPromise;
        return this.rules;
    }
};
